module.exports = __webpack_public_path__ + "static/img/20.a4ace88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/20.png
// module id = piEN
// module chunks = 0